import {useParams} from 'react-router-dom';
import {Activity} from 'api';

const useProjectName = (activity: Activity) => {
  const {projectId} = useParams<{projectId: string}>();

  const getProjectName = () => {
    if (activity?.project === null) {
      return '（削除済み)';
    } else if (projectId !== activity?.project?.uuid) {
      return activity?.project?.name;
    } else {
      return null;
    }
  };

  const projectName = getProjectName();

  return {projectName};
};

export default useProjectName;
